import { render, staticRenderFns } from "./TiptapConfig.vue?vue&type=template&id=16aad1ab&scoped=true"
import script from "./TiptapConfig.vue?vue&type=script&lang=js"
export * from "./TiptapConfig.vue?vue&type=script&lang=js"
import style0 from "./TiptapConfig.vue?vue&type=style&index=0&id=16aad1ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16aad1ab",
  null
  
)

export default component.exports